export default "__VITE_ASSET__wPGygqQf__"